import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from "@angular/router";
import { CookieService } from './core/services/cookie/cookie-service.service';

import { APP_SETTINGS, AuthService, SettingService } from '@services';
import { AnalyticsService } from './core/services/analytics/analytics.service';
import { UtilityService } from './core/services/utility/utility.service';
import { UserProfileService } from './features/user-profile/user-profile.service';
import { is3rdPartyHost } from './shared/utils/utils';
import { NgIf } from '@angular/common';
import { HeaderComponent } from './features/header/header.component';
import { CmsNavbarComponent } from './features/cms-navbar/cms-navbar.component';
import { SpinnerComponent } from './features/spinner/spinner.component';
import { FooterComponent } from './features/footer/footer.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        HeaderComponent,
        CmsNavbarComponent,
        SpinnerComponent,
        RouterOutlet,
        FooterComponent,
    ],
})
export class AppComponent implements OnInit {

  public showAdminNavbar = false;
  public showSpinner = false;
  public userRoles = {};
  public APP_SETTINGS: any;
  public showFooter = true;

  hideNavbar: boolean = false;
  userInfoFlag: boolean = true;
  isAdminUser: boolean = false;
  isBMW: boolean = false;
  isMINI: boolean = false;
  isMOTORRAD: boolean = false;
  isRollsRoyce: boolean = false;
  screenWidth: number;

  constructor(private utilityService: UtilityService,
    private userProfileService: UserProfileService,
    private router: Router,
    private authService: AuthService,
    private cookieService: CookieService,
    private analyticsService: AnalyticsService,
    private cdRef: ChangeDetectorRef,
    private settingsService: SettingService,
    private ngZone: NgZone) {
    this.screenWidth = this.utilityService.getScreenWidth();
    this.analyticsService.injectAdobeLaunchScript();
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }

    if (this.isExternalLink(router['url'])) {
      this.hideNavbar = true;
      this.showAdminNavbar = false;
    } else {
      this.hideNavbar = false;
    }
    
    if (is3rdPartyHost()) {
      APP_SETTINGS.isExternal = 'true';
      APP_SETTINGS.isDealer = 'false';
      if ((APP_SETTINGS.isBMW == null || APP_SETTINGS.isBMW == "") && (this.userInfoFlag)) {
        this.userInfoFlag = false;
        this.userProfileService.getTisParamDetails("APP_HOST").subscribe(data => {
          let linemake = data['TisParam']['paramValue'];

          if (linemake === 'BMW') {
            APP_SETTINGS.isMINI = 'false';
            APP_SETTINGS.isMOTORRAD = 'false';
            APP_SETTINGS.isBMW = 'true';
            APP_SETTINGS.isRollsRoyce = 'false';
            APP_SETTINGS.brandType = 'false';
            this.isBMW = true;
          } else if (linemake === 'MINI') {
            APP_SETTINGS.isBMW = 'false';
            APP_SETTINGS.isMOTORRAD = 'false';
            APP_SETTINGS.isMINI = 'true';
            APP_SETTINGS.isRollsRoyce = 'false';
            APP_SETTINGS.brandType = 'true';
            this.isMINI = true;
          } else if (linemake === 'MOTORRAD') {
            APP_SETTINGS.isBMW = 'false';
            APP_SETTINGS.isMINI = 'false';
            APP_SETTINGS.isMOTORRAD = 'true';
            APP_SETTINGS.isRollsRoyce = 'false';
            APP_SETTINGS.brandType = 'false';
            this.isMOTORRAD = true;
          }
          else if (linemake === 'ROLLSROYCE') {
            APP_SETTINGS.isBMW = 'false';
            APP_SETTINGS.isMINI = 'false';
            APP_SETTINGS.isMOTORRAD = 'false';
            APP_SETTINGS.isRollsRoyce = 'true';
            APP_SETTINGS.brandType = 'true';
            this.isRollsRoyce = true;
          }
          this.router.navigated = false;
          this.router.navigateByUrl(router['url']);
          this.settingsService.updateActiveSettings(APP_SETTINGS)
        }, error => {
          console.error("AppComponent Error - app component getTisParamDetails call errored" + error.error);
        });
      }
    } else {
      this.initializeUserInfo();
    }
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {

        if (this.isExternalLink(event['url']) && APP_SETTINGS.isExternal == 'false' && (window.location.origin.indexOf('localhost') < 0)) {
          this.router.navigateByUrl('/home');
          return;
        }

        if (this.isExternalLink(event['url'])) {
          this.hideNavbar = true;
          this.showAdminNavbar = false;
          this.showFooter = true;
        }
        else if (event['url'] === '/logout') {
          this.hideNavbar = true;
          this.showAdminNavbar = false;
          this.showFooter = false;
          this.userRoles = null;
          /* This logic is added because the header is not displayed properly on the logout screen */
          if (APP_SETTINGS.isBMW == 'true')
            this.isBMW = true;
          else
            this.isBMW = false;
        }
        else if (event['url'] === '/tis-support' && APP_SETTINGS.isExternal == 'true') {
          this.hideNavbar = true;
          this.showAdminNavbar = false;
          this.showFooter = true;
          this.userRoles = null;
        }
        else {
          this.userRoles = JSON.parse(localStorage.getItem('USER_INFO'));
          if ((this.userRoles == null || !this.cookieService.getCookie("tis_user") || this.cookieService.getCookie("tis_user") == null) && APP_SETTINGS.isExternal == 'true') {
            this.hideNavbar = true;
            this.showAdminNavbar = false;
            this.showFooter = true;
            this.router.navigated = false;

            if (event['url'] && event['url'].indexOf('/oss') >= 0) {
              this.router.navigate(['/login'], { queryParams: { returnUrl: event['url'] } });
            } else {
              this.router.navigateByUrl('/login');
            }
          } else {
            var styleCheck = setInterval(() => {
              this.APP_SETTINGS = APP_SETTINGS;
              if (this.APP_SETTINGS['isAdmin'] === 'true' ||
                this.APP_SETTINGS['isMotorradAdmin'] === 'true' ||
                this.APP_SETTINGS['isBPMAdmin'] === 'true' ||
                this.APP_SETTINGS['isPartAdmin'] === 'true' ||
                this.APP_SETTINGS['isSIBAdmin'] === 'true' ||
                this.APP_SETTINGS['isRollsRoyceAdmin'] === 'true') {
                this.showAdminNavbar = true;
              }
              if (this.APP_SETTINGS.isMINI != '' && this.APP_SETTINGS.isBMW != '') {
                clearInterval(styleCheck);
                this.cdRef.detectChanges();
              }
            }, 1000);
            this.hideNavbar = false;
            if (APP_SETTINGS['isAdmin'] === 'true' ||
              APP_SETTINGS['isMotorradAdmin'] === 'true' ||
              APP_SETTINGS['isBPMAdmin'] === 'true' ||
              APP_SETTINGS['isPartAdmin'] === 'true' ||
              APP_SETTINGS['isSIBAdmin'] === 'true' ||
              APP_SETTINGS['isRollsRoyceAdmin'] === 'true') {
              this.showAdminNavbar = true;
            }
            this.showFooter = true;
          }
        }
      }
    });

  }

  public isExternalLink(routeString): boolean {
    if (routeString === '/login' ||
      routeString === '/signup' ||
      routeString === '/reset-password' ||
      routeString === '/paypal-login' ||
      routeString === '/disclaimer' ||
      (routeString.indexOf('/login') > -1) ||
      (routeString.indexOf('/signup') > -1) ||
      (routeString.indexOf('/reset-password') > -1) ||
      (routeString.indexOf('/paypal-login') > -1)
    ) {
      return true;
    }
    return false;
  }

  toggleAdminNavbar() {
    this.showAdminNavbar = !this.showAdminNavbar;
  }

  initializeUserInfo(): Promise<any> {
    return new Promise<void>((resolve, reject) => {

      let brandType;
      this.userProfileService.getUserRoles().subscribe(data => {
        if (data.hasOwnProperty('username')) {
          brandType = data['isMini'];
          if (data.isExternal === 'false') {
            APP_SETTINGS.brandType = brandType;
            APP_SETTINGS.isBMW = data['isBMW'];
            APP_SETTINGS.isMINI = data['isMini'];
            APP_SETTINGS.isMOTORRAD = data['isMotorrad'];
            APP_SETTINGS.isRollsRoyce = data['isRollsRoyce'];
          }

          //This handles use case where user is given both the Admin and the Motorrad Admin role
          if (data.isAdmin === 'true' && data.isMotorradAdmin === 'true') {
            APP_SETTINGS.isAdmin = 'true';
            APP_SETTINGS.isMotorradAdmin = 'false';
          } else if (data.isAdmin === 'false' && data.isMotorradAdmin === 'true') {
            APP_SETTINGS.isAdmin = 'false';
            APP_SETTINGS.isMotorradAdmin = 'true';
          } else if (data.isAdmin === 'true' && data.isMotorradAdmin === 'false') {
            APP_SETTINGS.isAdmin = 'true';
            APP_SETTINGS.isMotorradAdmin = 'false';
          } else if (data.isAdmin === 'false' && data.isMotorradAdmin === 'false') {
            APP_SETTINGS.isAdmin = 'false';
            APP_SETTINGS.isMotorradAdmin = 'false';
          }

          if (data.isAdmin === 'true' && data.isRollsRoyceAdmin === 'true') {
            APP_SETTINGS.isAdmin = 'true';
            APP_SETTINGS.isRollsRoyceAdmin = 'false';
          } else if (data.isAdmin === 'false' && data.isRollsRoyceAdmin === 'true') {
            APP_SETTINGS.isAdmin = 'false';
            APP_SETTINGS.isRollsRoyceAdmin = 'true';
          } else if (data.isAdmin === 'true' && data.isRollsRoyceAdmin === 'false') {
            APP_SETTINGS.isAdmin = 'true';
            APP_SETTINGS.isRollsRoyceAdmin = 'false';
          } else if (data.isAdmin === 'false' && data.isRollsRoyceAdmin === 'false') {
            APP_SETTINGS.isAdmin = 'false';
            APP_SETTINGS.isRollsRoyceAdmin = 'false';
          }

          if (data.isAdmin === 'true') {
            this.isAdminUser = true;
          }

          APP_SETTINGS.isExternal = data.isExternal;
          APP_SETTINGS.isBPMAdmin = data.isBPMAdmin;
          APP_SETTINGS.isMasterAdmin = data.isMasterAdmin;
          APP_SETTINGS.isPartAdmin = data.isPartAdmin;
          APP_SETTINGS.isSIBAdmin = data.isSIBAdmin;
          APP_SETTINGS.sessionId = data.sessionId;
          APP_SETTINGS.isDealer = data.isDealer;

          if (APP_SETTINGS.isDealer === 'true') {
            APP_SETTINGS.centerID = data.centerId;
            APP_SETTINGS.locationCode = data.locationCode;
            if (APP_SETTINGS.isBMW === 'true') {
              this.userProfileService.getBMWDealerLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode).subscribe(BMWdata => {
                APP_SETTINGS.dealerCode = BMWdata.dealerCode;
                APP_SETTINGS.marketCode = BMWdata.marketCode;
                APP_SETTINGS.marketDescription = BMWdata.marketDescription;
                APP_SETTINGS.regionCode = BMWdata.regionCode;
                APP_SETTINGS.regionDescription = BMWdata.regionDescription;

                this.analyticsService.trackDealerLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                if (this.screenWidth >= 991) {
                  this.analyticsService.trackDealerWebLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                } else if (this.screenWidth < 991 && this.screenWidth > 319) {
                  this.analyticsService.trackDealerMobileLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                }
              });
            }
            else if (APP_SETTINGS.isMINI === 'true') {
              this.userProfileService.getMINIDealerLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode).subscribe(MINIdata => {
                APP_SETTINGS.dealerCode = MINIdata.dealerCode;
                APP_SETTINGS.marketCode = MINIdata.marketCode;
                APP_SETTINGS.marketDescription = MINIdata.marketDescription;
                APP_SETTINGS.regionCode = MINIdata.regionCode;
                APP_SETTINGS.regionDescription = MINIdata.regionDescription;
                this.analyticsService.trackDealerLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);

                if (this.screenWidth >= 991) {
                  this.analyticsService.trackDealerWebLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                } else if (this.screenWidth < 991 && this.screenWidth > 319) {
                  this.analyticsService.trackDealerMobileLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                }
              });
            }
            else if (APP_SETTINGS.isMOTORRAD === 'true') {
              this.userProfileService.getMOTORRADDealerLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode).subscribe(Motorraddata => {
                APP_SETTINGS.dealerCode = Motorraddata.dealerCode;
                APP_SETTINGS.marketCode = Motorraddata.marketCode;
                APP_SETTINGS.marketDescription = Motorraddata.marketDescription;
                APP_SETTINGS.regionCode = Motorraddata.regionCode;
                APP_SETTINGS.regionDescription = Motorraddata.regionDescription;

                this.analyticsService.trackDealerLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                if (this.screenWidth >= 991) {
                  this.analyticsService.trackDealerWebLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                } else if (this.screenWidth < 991 && this.screenWidth > 319) {
                  this.analyticsService.trackDealerMobileLoginLocation(APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode, APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription);
                }
              });
            }

          }
          if (data.isMini === 'true') {
            APP_SETTINGS.videoThumbnail = APP_SETTINGS.miniVideoThumbnail;
            APP_SETTINGS.videoThumbnailHeight = "45px";
            APP_SETTINGS.videoThumbnailWidth = "20px";
          }

          if (data.isRollsRoyce === 'true') {
            APP_SETTINGS.videoThumbnail = APP_SETTINGS.rollsRoyceVideoThumbnail;
            APP_SETTINGS.videoThumbnailHeight = "45px";
            APP_SETTINGS.videoThumbnailWidth = "20px";
          }
          this.authService.setUserSession('USER_INFO', JSON.stringify(data));
        }
        this.settingsService.updateActiveSettings(APP_SETTINGS);
        this.cdRef.detectChanges();
      },
        // Added to handle accessdenied as part of WEN migration
        (error: HttpErrorResponse) => {
          console.error('Http status thrown from backend at user-details: ', error.error);
          if (error.status == 403) {
            this.hideNavbar = true;
            this.showAdminNavbar = false;
            this.showFooter = false;
            this.router.navigateByUrl('/accessdenied');
          }
        });
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  }
}
